import { combineReducers } from '@reduxjs/toolkit';
import signInReducer from './slices/SignInSlice';
import signUpReducer from './slices/SignupSlice';
import globalCatalogueReducer from './slices/GlobalCatalogueSlice';
import activeOrganisationReducer from './slices/ActiveOrganisationSlice';
import farmReducer from './slices/FarmSlice';
import inputReducer from './slices/InputSlice';
import insightsReducer from './slices/InsightsSlice';
import staffReducer from './slices/StaffSlice';

const rootReducer = combineReducers({
  signInReducer,
  signUpReducer,
  globalCatalogueReducer,
  activeOrganisationReducer,
  farmReducer,
  inputReducer,
  insightsReducer,
  staffReducer,
});

export default rootReducer;
